/*
  BluFood Produktkarte (bf D9) – "In den Warenkorb" auf der Karte (snippets/bf-product-card.liquid)
  - Eine lieferbare Variante: Formular data-bf-card-add -> /cart/add.js, danach Warenkorb-Drawer oeffnen.
  - R25: Mehrere lieferbare Varianten: Link data-bf-quick oeffnet das Auswahlfenster (<dialog>).
    Inhalt: <Produkt-URL>?view=schnellkauf (templates/product.schnellkauf.json, sections/bf-quick-add),
    Mengen aufsteigend, guenstigste vorausgewaehlt, Anzahl +/−, Preis im Knopf = Zeilenpreis × Anzahl.
    Ohne JavaScript oder bei Fehlern: normale Produktseite.
  Ohne JavaScript oder ohne Drawer: normales Formular an /cart/add bzw. Weiterleitung zum Warenkorb.
*/

const root = () => ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/')
const FAIL = 'Das hat leider nicht geklappt. Bitte versuche es noch einmal.'
const JSON_HEADERS = { 'Content-Type': 'application/json', Accept: 'application/json' }

async function addToCart (id, quantity) {
  const res = await fetch(root() + 'cart/add.js', {
    method: 'POST',
    headers: JSON_HEADERS,
    credentials: 'same-origin',
    body: JSON.stringify({ items: [{ id, quantity }] })
  })
  const data = await res.json().catch(() => ({}))
  if (!res.ok || data.status) throw new Error(data.description || data.message || FAIL)
  return data
}

async function openDrawer () {
  const drawer = window.BF && window.BF.cartDrawer
  if (drawer) {
    await drawer.refresh()
    drawer.open()
  } else {
    window.location.href = root() + 'cart'
  }
}

async function onSubmit (e) {
  const form = e.target.closest && e.target.closest('form[data-bf-card-add]')
  if (!form) return
  e.preventDefault()
  const btn = form.querySelector('button[type="submit"]')
  const msg = form.querySelector('[data-bf-card-msg]')
  if (!btn || btn.getAttribute('aria-disabled') === 'true') return
  // Auswahl per Radio (z. B. Creator-Seite) oder verstecktes Feld (Produktkarte)
  const idInput = form.querySelector('input[name="id"]:checked') || form.querySelector('input[name="id"]:not([type="radio"])')
  if (!idInput) return
  btn.setAttribute('aria-disabled', 'true')
  btn.classList.add('is-loading')
  if (msg) msg.hidden = true
  try {
    await addToCart(Number(idInput.value), 1)
    await openDrawer()
  } catch (err) {
    if (msg) {
      msg.textContent = err.message || FAIL
      msg.hidden = false
    }
  } finally {
    btn.removeAttribute('aria-disabled')
    btn.classList.remove('is-loading')
  }
}

/* ---------- R25: Auswahlfenster ---------- */

let dialog = null

function formatMoney (cents, format) {
  const fmt = format || '{{amount_with_comma_separator}} €'
  const value = (Number(cents) || 0) / 100
  const group = (n, sep) => String(n).replace(/\B(?=(\d{3})+(?!\d))/g, sep)
  const parts = (decimals, thousands, decimalSep) => {
    const fixed = value.toFixed(decimals).split('.')
    return group(fixed[0], thousands) + (fixed[1] ? decimalSep + fixed[1] : '')
  }
  return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (m, key) => {
    switch (key) {
      case 'amount': return parts(2, ',', '.')
      case 'amount_no_decimals': return parts(0, ',', '.')
      case 'amount_no_decimals_with_comma_separator': return parts(0, '.', ',')
      case 'amount_with_comma_separator':
      default: return parts(2, '.', ',')
    }
  })
}

function ensureDialog () {
  if (dialog && document.body.contains(dialog)) return dialog
  dialog = document.createElement('dialog')
  dialog.className = 'bf-qa'
  dialog.setAttribute('aria-labelledby', 'BfQaTitle')
  dialog.innerHTML = '<button type="button" class="bf-qa__close" data-bf-qa-close aria-label="Schließen">' +
    '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>' +
    '</button><div class="bf-qa__body" data-bf-qa-body></div>'
  dialog.addEventListener('click', (e) => {
    if (e.target === dialog || e.target.closest('[data-bf-qa-close]')) dialog.close()
  })
  dialog.addEventListener('close', () => document.documentElement.classList.remove('bf-qa-open'))
  document.body.appendChild(dialog)
  return dialog
}

function ensureCss (link) {
  const href = link.getAttribute('href')
  if (!href) return Promise.resolve()
  const path = href.split('?')[0]
  const known = Array.from(document.querySelectorAll('link[rel="stylesheet"]')).some((l) => (l.getAttribute('href') || '').split('?')[0] === path)
  if (known) return Promise.resolve()
  return new Promise((resolve) => {
    const el = document.createElement('link')
    el.rel = 'stylesheet'
    el.href = href
    el.onload = resolve
    el.onerror = resolve
    document.head.appendChild(el)
    setTimeout(resolve, 2500)
  })
}

function bindQuick (box) {
  const form = box.querySelector('[data-bf-qa-form]')
  if (!form) return
  const fmt = box.dataset.moneyFormat
  const qty = form.querySelector('[data-bf-qa-qty]')
  const out = form.querySelector('[data-bf-qa-price]')
  const msg = form.querySelector('[data-bf-qa-msg]')
  const btn = form.querySelector('button[type="submit"]')
  const current = () => form.querySelector('input[name="id"]:checked')
  const count = () => Math.min(99, Math.max(1, parseInt(qty && qty.value, 10) || 1))
  const update = () => {
    const r = current()
    if (out && r) out.textContent = formatMoney(Number(r.dataset.price) * count(), fmt)
  }
  form.addEventListener('change', update)
  if (qty) qty.addEventListener('input', update)
  form.addEventListener('click', (e) => {
    const step = e.target.closest('[data-bf-qa-step]')
    if (!step || !qty) return
    qty.value = Math.min(99, Math.max(1, count() + Number(step.dataset.bfQaStep)))
    update()
  })
  form.addEventListener('submit', async (e) => {
    e.preventDefault()
    const r = current()
    if (!r || !btn || btn.getAttribute('aria-disabled') === 'true') return
    btn.setAttribute('aria-disabled', 'true')
    btn.classList.add('is-loading')
    if (msg) msg.hidden = true
    try {
      await addToCart(Number(r.value), count())
      dialog.close()
      await openDrawer()
    } catch (err) {
      if (msg) {
        msg.textContent = err.message || FAIL
        msg.hidden = false
      }
    } finally {
      btn.removeAttribute('aria-disabled')
      btn.classList.remove('is-loading')
    }
  })
  update()
}

async function openQuick (url) {
  const d = ensureDialog()
  const body = d.querySelector('[data-bf-qa-body]')
  body.innerHTML = '<div class="bf-qa__loading" role="status"><span class="bf-qa__spinner" aria-hidden="true"></span><span class="bf-visually-hidden">Wird geladen</span></div>'
  document.documentElement.classList.add('bf-qa-open')
  if (!d.open) d.showModal()
  try {
    const res = await fetch(url + (url.indexOf('?') === -1 ? '?' : '&') + 'view=schnellkauf', { credentials: 'same-origin' })
    if (!res.ok) throw new Error('load')
    const doc = new DOMParser().parseFromString(await res.text(), 'text/html')
    const box = doc.querySelector('[data-bf-qa-root]')
    if (!box) throw new Error('content')
    await Promise.all(Array.from(doc.querySelectorAll('link[rel="stylesheet"]')).map(ensureCss))
    body.replaceChildren(document.importNode(box, true))
    bindQuick(body.querySelector('[data-bf-qa-root]'))
    const checked = body.querySelector('input[name="id"]:checked')
    if (checked) checked.focus({ preventScroll: true })
  } catch (err) {
    d.close()
    window.location.href = url
  }
}

function onClick (e) {
  const trigger = e.target.closest && e.target.closest('a[data-bf-quick]')
  if (!trigger || e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return
  if (typeof HTMLDialogElement === 'undefined') return
  e.preventDefault()
  openQuick(trigger.getAttribute('href'))
}

if (!window.__bfCardReady) {
  window.__bfCardReady = true
  document.addEventListener('submit', onSubmit)
  document.addEventListener('click', onClick)
}
